<div class="grid">
  <div [class]="activeUserStore.canAccessEntityAdder() ? 'col-7' : 'col-12'">
    @if (store.asArray(); as colorsets) {
      @if (colorsets.length > 0) {
        <p-table
          #colorsetTable
          [globalFilterFields]="['name']"
          [loading]="loading"
          [value]="colorsets">
          <ng-template pTemplate="caption">
            <app-table-list-caption
              [searchWord]="searchWord"
              (clearTable)="clear(colorsetTable)"
              (search)="
                colorsetTable.filterGlobal($event, 'contains')
              "></app-table-list-caption>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>Name</th>
              <th>Farben</th>
              <th>Aktionen</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-colorset>
            <tr>
              <td>
                <span class="flex align-items-center gap-3"
                  ><i [class]="'w-1rem text-center fas fa-palette'"></i>
                  {{ colorset.name }}</span
                >
              </td>
              <td class="max-w-10rem overflow-auto">
                <app-colors [colorset]="colorset" />
              </td>
              <td>
                <app-table-list-actions
                  [item]="colorset"
                  (confirm)="confirm($event, colorset, colorset.name)">
                </app-table-list-actions>
              </td>
            </tr>
          </ng-template>
        </p-table>
      } @else {
        <app-alert header="Keine Farbsets gefunden" [canToggle]="false">
          Legen Sie eigene
          <a
            [routerLink]="[
              '/data-backend',
              {
                outlets: {
                  overlay: ['farbsets', { outlets: { bearbeiten: 'neu' } }],
                },
              },
            ]"
            >Farbsets</a
          >
          an, und nutzen sie diese in Ihren Darstellungen oder Karten.
        </app-alert>
      }
    }
  </div>
  @if (activeUserStore.canAccessEntityAdder()) {
    <div class="col-5">
      <app-header text="Vorlagen" icon="fas fa-swatchbook" />
      <div class="p-card surface-ground p-3">
        @for (colorsetTemplate of colorsetTemplates; track $index) {
          <div
            [routerLink]="[
              {
                outlets: { bearbeiten: 'neu' },
              },
            ]"
            [queryParams]="{ templateIndex: $index }"
            class="flex align-items-center gap-4 p-2 mv-1 hover:surface-100 border-round-sm transition-duration-200 transition-linear cursor-pointer">
            <i class="fas fa-copy"></i>
            <app-colors [colorset]="colorsetTemplate"></app-colors>
            <i>{{ colorsetTemplate.name }}</i>
          </div>
        }
      </div>
    </div>
  }
</div>
<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-10'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
